module.exports = __webpack_public_path__ + "img/far_night_cyl125_axis0.c4362c09.jpg";